export enum CompensationStatus {
  Pending = 'Pending',
  Approved = 'Approved',
  Rejected = 'Rejected',
  UpdateRequired = 'UpdateRequired',
  Closed = 'Closed',
  Failed = 'Failed',
}
